import { jsx } from 'react/jsx-runtime';

var n=({children:o,size:t,...e})=>jsx("svg",{...e,fill:"none",height:t,width:t,children:o});var c=o=>jsx(n,{...o,viewBox:"0 0 16 16",children:jsx("path",{d:"M2.27393 7.83325H14.059",stroke:"currentcolor",strokeWidth:"0.8",strokeMiterlimit:"10",strokeLinecap:"round",strokeLinejoin:"round"})}),I=c;

export { I as default };
